document.addEventListener('DOMContentLoaded', async function() {
    if (window.scriptInitialized) return;
    window.scriptInitialized = true;
    const shopUrl = Shopify.shop;
    const fetchProductDetails = async (tag) => {
        const storefrontAccessToken = window.storefrontAccessToken;
        const url = `https://${shopUrl}/api/2024-10/graphql.json`;
    
        const productQuery = `
                query Products($query: String!, $country: CountryCode) @inContext(country: $country) {
                    products(first: 100, query: $query) {
                        edges {
                            node {
                                id
                                title
                                handle
                                discontinued: metafield(namespace: "custom", key: "discontinued") {
                                    value
                                    type
                                }
                                variantSwatchColor: metafield(namespace: "custom", key: "variant_swatch_color") {
                                    value
                                    type
                                }
                                totalInventory
                                priceRange {
                                    maxVariantPrice {
                                        amount
                                        currencyCode
                                    }
                                    minVariantPrice {
                                        amount
                                        currencyCode
                                    }
                                }
                                images(first: 2) {
                                    edges {
                                        node {
                                            src
                                            altText
                                        }
                                    }
                                }
                                variants(first: 100) {
                                    edges {
                                        node {
                                            id
                                            title
                                            quantityAvailable
                                            compareAtPrice {
                                                amount
                                                currencyCode
                                            }
                                            selectedOptions {
                                                name
                                                value
                                            }
                                            image {
                                                src
                                                altText
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            `;
    
        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                "X-Shopify-Storefront-Access-Token": storefrontAccessToken,
                "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    query: productQuery,
                    variables: {
                        query: `tag:${tag}`,
                        country: Shopify.country,
                    },
                })
            });
        
            const { data, errors } = await response.json();
        
            if (errors) {
                console.error("GraphQL Errors:", errors);
                return null;
            }
        
            if (data && data.products.edges) {
                const productDetails = data.products.edges.map(({ node }) => {
                    if (node) {
                        return node;
                    } else {
                        console.warn("Encountered a null product.");
                        return null;
                    }
                }).filter(Boolean);

                return productDetails;
            } else {
                console.warn("No product data found.");
                return null;
            }
        } catch (error) {
          console.error("Error fetching product:", error);
          return [];
        }
    };

    // Original PDP/recommendations fetch: resolve sibling colors by product GID
    // (from custom.product_custom_swatch), matching facets.js — not tag:style queries.
    const fetchProductDetailsByGid = async (productId) => {
        let storefrontAccessToken;
        try {
            storefrontAccessToken = window.storefrontAccessToken
                || (window.waitForStorefrontToken && await window.waitForStorefrontToken());
        } catch (error) {
            console.error('Storefront token not ready:', error);
            return null;
        }

        const gid = String(productId).startsWith('gid://')
            ? productId
            : `gid://shopify/Product/${productId}`;
        const url = `https://${shopUrl}/api/2024-10/graphql.json`;

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
                },
                body: JSON.stringify({
                    query: `query Product($id: ID!, $country: CountryCode) @inContext(country: $country) {
                        node(id: $id) {
                            ... on Product {
                                id
                                title
                                handle
                                totalInventory
                                priceRange {
                                    minVariantPrice {
                                        amount
                                        currencyCode
                                    }
                                    maxVariantPrice {
                                        amount
                                        currencyCode
                                    }
                                }
                                discontinued: metafield(namespace: "custom", key: "discontinued") {
                                    value
                                    type
                                }
                                variantSwatchColor: metafield(namespace: "custom", key: "variant_swatch_color") {
                                    value
                                    type
                                }
                                priceRange {
                                    minVariantPrice {
                                        amount
                                        currencyCode
                                    }
                                    maxVariantPrice {
                                        amount
                                        currencyCode
                                    }
                                }
                                images(first: 2) {
                                    edges {
                                        node {
                                            url
                                            altText
                                        }
                                    }
                                }
                                variants(first: 50) {
                                    edges {
                                        node {
                                            id
                                            title
                                            quantityAvailable
                                            price {
                                                amount
                                                currencyCode
                                            }
                                            compareAtPrice {
                                                amount
                                                currencyCode
                                            }
                                            selectedOptions {
                                                name
                                                value
                                            }
                                            image {
                                                url
                                                altText
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }`,
                    variables: {
                        id: gid,
                        country: Shopify.country,
                    },
                }),
            });

            const data = await response.json();
            const product = data?.data?.node;
            if (!product) {
                return null;
            }

            return {
                ...product,
                images: {
                    edges: (product.images?.edges || []).map((edge) => ({
                        node: {
                            src: edge.node?.url || '',
                            altText: edge.node?.altText || '',
                        },
                    })),
                },
                variants: {
                    edges: (product.variants?.edges || []).map((edge) => ({
                        node: {
                            ...edge.node,
                            image: edge.node?.image
                                ? {
                                    src: edge.node.image.url || '',
                                    altText: edge.node.image.altText || '',
                                }
                                : null,
                        },
                    })),
                },
            };
        } catch (error) {
            console.error('Error fetching product by GID:', error);
            return null;
        }
    };

    const fetchRecommendationProductDetails = async (settings, productStyleNo) => {
        const gids = Array.isArray(settings?.product_gids)
            ? settings.product_gids.filter(Boolean)
            : [];

        if (gids.length) {
            const products = await Promise.all(gids.map(fetchProductDetailsByGid));
            return products.filter(Boolean);
        }

        if (!productStyleNo) {
            return [];
        }

        return (await fetchProductDetails(productStyleNo)) || [];
    };

    const RECOMMENDATION_SWATCH_VISIBLE_LIMIT = 6;

    const parseAvailableColorSwatches = (raw) => {
        if (!raw) {
            return [];
        }
        try {
            const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
            if (Array.isArray(parsed)) {
                return parsed;
            }
            if (Array.isArray(parsed?.swatches)) {
                return parsed.swatches;
            }
            return [];
        } catch (error) {
            return [];
        }
    };

    const getAvailableColorSwatchesForCard = (productId, settings) => {
        const fromSettings = parseAvailableColorSwatches(settings?.available_color_swatches);
        if (fromSettings.length) {
            return fromSettings;
        }

        const jsonEl = document.getElementById(`available_color_swatches_${productId}`);
        if (jsonEl?.textContent?.trim()) {
            return parseAvailableColorSwatches(jsonEl.textContent.trim());
        }

        return [];
    };

    const normalizeRecommendationSwatchUrl = (url) => {
        if (!url) {
            return '';
        }
        try {
            const parsed = new URL(url, window.location.origin);
            const variant = parsed.searchParams.get('variant');
            return variant
                ? `${parsed.pathname}?variant=${variant}`
                : parsed.pathname;
        } catch (error) {
            return String(url).split('&pr_')[0];
        }
    };

    const resolveRecommendationSwatchStyle = (swatch, keyArray, valArray) => {
        if (swatch.style) {
            return String(swatch.style).trim().replace(/;+\s*$/, '');
        }

        let colorValue = (swatch.color || swatch.label || '').toLowerCase().trim();
        const customColorIndex = keyArray.indexOf(colorValue);
        if (customColorIndex > -1) {
            colorValue = valArray[customColorIndex];
        }

        let bgValue = false;
        const swatchColor = swatch.swatchColor || '';
        if (swatchColor) {
            const swatchParts = String(swatchColor).split('-');
            const lastPart = swatchParts[swatchParts.length - 1].trim();
            if (lastPart.includes('#')) {
                colorValue = lastPart;
            } else if (lastPart) {
                bgValue = lastPart;
                colorValue = 'var(--bg-body)';
            }
        } else if (
            (window.NatoriColorSwatches && window.NatoriColorSwatches.isSwatchImageValue)
                ? window.NatoriColorSwatches.isSwatchImageValue(colorValue)
                : colorValue.includes('.')
        ) {
            bgValue = colorValue;
            colorValue = 'var(--bg-body)';
        }

        const shopDomain = window.location.hostname;
        const bgImageUrl = (window.NatoriColorSwatches && window.NatoriColorSwatches.swatchBackgroundImageCss)
            ? window.NatoriColorSwatches.swatchBackgroundImageCss(bgValue, shopDomain)
            : (bgValue ? `--option-color-image: url('//${shopDomain}/cdn/shop/files/${bgValue}');` : '');

        return [`--option-color: ${colorValue}`, bgImageUrl].filter(Boolean).join('; ');
    };

    const renderRecommendationSwatchFromMetafield = (
        swatch,
        currentProductId,
        featuredVariantId,
        keyArray,
        valArray,
        { overflow = false } = {}
    ) => {
        const color = swatch.color || swatch.label || '';
        if (!color) {
            return '';
        }

        const swatchProductId = String(swatch.productId || '').replace('gid://shopify/Product/', '');
        const swatchVariantId = String(swatch.variantId || '').replace('gid://shopify/ProductVariant/', '');
        const active =
            (swatchProductId && swatchProductId === String(currentProductId)) ||
            (swatchVariantId && String(swatchVariantId) === String(featuredVariantId))
                ? 'active'
                : '';
        const overflowClass = overflow ? 'product-card-swatch--overflow' : '';
        const style = resolveRecommendationSwatchStyle(swatch, keyArray, valArray);
        const primaryImage = swatch.primaryImage || swatch.image || '';
        const secondaryImage = swatch.secondaryImage || swatch.image2 || '';
        const href = normalizeRecommendationSwatchUrl(swatch.url || '');
        const available = swatch.available !== false;
        const price = swatch.price ?? swatch.variantPrice ?? '';
        const compareAt =
            swatch.compareAtPrice ?? swatch.compare_at_price ?? swatch.compareAt ?? '';

        return `
            <div
                class="product-card-swatch ${active} ${overflowClass}"
                style="${style};"
                data-srcset="${primaryImage}"
                data-srcset-2="${secondaryImage}"
                data-srcset-alt="${swatch.primaryImageAlt || ''}"
                data-srcset-2-alt="${swatch.secondaryImageAlt || ''}"
                data-href="${href}"
                data-quan="${available}"
                data-price="${price}"
                data-compare-at-price="${compareAt}"
            >
                <span class="visually-hidden">${color}</span>
            </div>
        `;
    };

    const hydrateRecommendationSwatchesFromMetafield = (
        productId,
        settings,
        container,
        keyArray,
        valArray
    ) => {
        const swatches = getAvailableColorSwatchesForCard(productId, settings);
        if (!swatches.length || !container) {
            return false;
        }

        const featuredVariantId = settings?.featured_image_id;
        const ordered = [...swatches];
        const activeIndex = ordered.findIndex((swatch) => {
            const swatchProductId = String(swatch.productId || '').replace('gid://shopify/Product/', '');
            const swatchVariantId = String(swatch.variantId || '').replace('gid://shopify/ProductVariant/', '');
            return (
                (swatchProductId && swatchProductId === String(productId)) ||
                (swatchVariantId && String(swatchVariantId) === String(featuredVariantId))
            );
        });
        if (activeIndex > 0) {
            const [activeSwatch] = ordered.splice(activeIndex, 1);
            ordered.unshift(activeSwatch);
        }

        const visible = ordered.slice(0, RECOMMENDATION_SWATCH_VISIBLE_LIMIT);
        const overflow = ordered.slice(RECOMMENDATION_SWATCH_VISIBLE_LIMIT);
        let html = visible
            .map((swatch) =>
                renderRecommendationSwatchFromMetafield(
                    swatch,
                    productId,
                    featuredVariantId,
                    keyArray,
                    valArray
                )
            )
            .join('');

        if (overflow.length) {
            html += `<button
                type="button"
                class="product-card-swatch-more morebtn"
                aria-expanded="false"
                aria-label="Show ${overflow.length} more color options"
            ><span class="product-card-swatch-more__desktop">+ MORE</span><span class="product-card-swatch-more__mobile" aria-hidden="true">+</span></button>`;
            html += overflow
                .map((swatch) =>
                    renderRecommendationSwatchFromMetafield(
                        swatch,
                        productId,
                        featuredVariantId,
                        keyArray,
                        valArray,
                        { overflow: true }
                    )
                )
                .join('');
        }

        container.innerHTML = html;

        const productCard = container.closest('product-card');
        if (productCard && !productCard.getAttribute('data-default-compare-at-price')) {
            let maxCompare = null;
            ordered.forEach((swatch) => {
                [swatch.compareAtPrice, swatch.compare_at_price, swatch.compareAt, swatch.price].forEach((raw) => {
                    const cents = Number.parseFloat(String(raw || '').replace(/[^0-9.]/g, ''));
                    if (!Number.isFinite(cents)) {
                        return;
                    }
                    if (maxCompare == null || cents > maxCompare) {
                        maxCompare = cents;
                    }
                });
            });
            if (maxCompare != null) {
                productCard.setAttribute('data-default-compare-at-price', String(maxCompare));
            }
        }

        return container.querySelectorAll('.product-card-swatch[data-href]').length > 0;
    };
  
    // const fetchProductDetails = async (productId) => {
    //   try {
    //     const response = await fetch(
    //     "https://natori-sandbox.myshopify.com/admin/api/2024-04/graphql.json",
    //       {
    //         method: "POST",
    //         headers: {
    //           "Content-Type": "application/json",
    //           "X-Shopify-Access-Token": storefrontAccessToken,
    //         },
    //         body: JSON.stringify({
    //           query: `{
    //                     node(id: "${productId}") {
    //                         ... on Product {
    //                             title
    //                             handle
    //                             metafield(namespace: "custom", key: "discontinued") {
    //                                 value
    //                                 type
    //                             }
    //                             images(first: 2) {
    //                                 edges {
    //                                     node {
    //                                         src
    //                                         altText
    //                                     }
    //                                 }
    //                             }
    //                             variants(first: 100) {
    //                                 edges {
    //                                     node {
    //                                         id
    //                                         title
    //                                         inventoryQuantity
    //                                         selectedOptions {
    //                                             name
    //                                             value
    //                                         }
    //                                         image {
    //                                             src
    //                                             altText
    //                                         }
    //                                     }
    //                                 }
    //                             }
    //                         }
    //                     }
    //                 }`,
    //         }),
    //       }
    //     );
        
    //     const data = await response.json();
        
    //     if (data && data.data && data.data.node) {
    //       const variants = data.data.node.variants.edges;
          
    //       const isAvailable = variants.some(variant => variant.node.inventoryQuantity > 0);
          
    //       const productDetails = {
    //         ...data.data.node,
    //         available: isAvailable
    //       };
          
    //       return productDetails;
    //     } else {
    //       return "";
    //     }
    //   } catch (error) {
    //     console.log("Error fetching product:", error);
    //     throw error;
    //   }
    // };
  
  
    const processProductDetails = async (
        product,
        keyArray,
        valArray,
        featuredImageId,
        productDataElements,
        productId,
        primaryImagesrc,
        secondaryImagesrc,
        mainHandle,
        uniqueColors,
        counter,
        productAvailable
    ) => {
        if (product && product.variants && product.variants.edges) {
            let storedVariants = JSON.parse(sessionStorage.getItem("natoriCustomVariants") || "{}" );
            let customVarList = storedVariants[productId]?.variants || [];
            for (const edge of product.variants.edges) {
                const variant = edge.node;
                const productQuan = productAvailable;
                if (variant) {
                    let variantCustomId = parseInt(variant.id.split("/").pop());
                    if (!customVarList.includes(variantCustomId)) {
                        for (const option of variant.selectedOptions) {
                            if ( option.name.toLowerCase() === "color" || option.name.toLowerCase() === "colour" || option.name.toLowerCase() === "couleur" ) {
                                const key = option.value;
                                if (!uniqueColors.has(key) && counter.count < 6) {
                                    uniqueColors.set(key, option);
                                    if (option.value.length > 0) {
                                        let swatchHtml = "";
                                        let active = "";
                                        let variantImage = "";
                                        let variantUrl = "";
                                        let srcset = "";
                                        let variantId = parseInt(variant.id.split("/").pop());
                                        if (variant) {
                                            if (variantId === featuredImageId) {
                                                active = "active";
                                            }
                                            if (primaryImagesrc) {
                                                variantImage = primaryImagesrc;
                                            }
                                            variantUrl = `/products/${product.handle}?variant=${variantId}`;
                                        }
                                        const imageSizes = "{{ sizes }}".split(",");
                    
                                        if (variantImage) {
                                            imageSizes.forEach((size) => {
                                                const sizeArray = size.split("x");
                                                const sizeX = sizeArray[0] + "x" + (sizeArray[1] !== "0" ? sizeArray[1] : "");
                                                srcset += `${variantImage.replace(".jpg", `_${sizeX}.jpg`)} ${sizeArray[0]}w, `;
                                            });
                                        }
                                        let colorValue = key.toLowerCase().trim();
                                        const customColorIndex = keyArray.indexOf(colorValue);
                                        if (customColorIndex > -1) {
                                            colorValue = valArray[customColorIndex];
                                        }
                                        let bgValue = false;
                                        const swatchColor = product.variantSwatchColor?.value;
                                        if (swatchColor) {
                                            const swatchParts = swatchColor.split("-");
                                            const lastPart =
                                                swatchParts[swatchParts.length - 1].trim();
                                            if (lastPart.includes("#")) {
                                                colorValue = lastPart;
                                            } else {
                                                bgValue = lastPart;
                                                colorValue = "var(--bg-body)";
                                            }
                                        } else {
                                            if ((window.NatoriColorSwatches && window.NatoriColorSwatches.isSwatchImageValue) ? window.NatoriColorSwatches.isSwatchImageValue(colorValue) : colorValue.includes(".")) {
                                                bgValue = colorValue;
                                                colorValue = "var(--bg-body)";
                                            }
                                        }
                                        const shopDomain = window.location.hostname;
                                        const bgImageUrl = (window.NatoriColorSwatches && window.NatoriColorSwatches.swatchBackgroundImageCss)
                                                    ? window.NatoriColorSwatches.swatchBackgroundImageCss(bgValue, shopDomain)
                                                    : (bgValue ? `--option-color-image: url('//${shopDomain}/cdn/shop/files/${bgValue}');` : "");
                                        const salePrice = product?.priceRange?.minVariantPrice?.amount;
                                        const compareAmounts = (product?.variants?.edges || [])
                                            .map((variantEdge) =>
                                                parseFloat(variantEdge?.node?.compareAtPrice?.amount)
                                            )
                                            .filter((amount) => Number.isFinite(amount));
                                        const compareAtPrice =
                                            salePrice != null &&
                                            compareAmounts.length &&
                                            Math.min(...compareAmounts) > parseFloat(salePrice)
                                                ? Math.min(...compareAmounts)
                                                : '';
                                        swatchHtml += `
                                                    <div class="product-card-swatch ${active}"
                                                        style="--option-color: ${colorValue}; ${bgImageUrl}" 
                                                        data-srcset-2="${secondaryImagesrc}" 
                                                        data-srcset="${variantImage}"
                                                        data-href="${variantUrl}"
                                                        data-quan="${productQuan}"
                                                        data-price="${salePrice != null ? salePrice : ''}"
                                                        data-compare-at-price="${compareAtPrice}">
                                                        <span class="visually-hidden">${key}</span>
                                                    </div>
                                                `;
                                        if (productDataElements) {
                                            const existingSwatches = productDataElements.querySelectorAll( ".product-card-swatch" );
                                            const isSwatchExists = existingSwatches.length > 0 && productDataElements.querySelector( `.product-card-swatch[data-href="${variantUrl}"]` );
                                            if (!isSwatchExists && existingSwatches.length < 6) {
                                                productDataElements.insertAdjacentHTML("beforeend",swatchHtml);
                                                counter.count++;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        if (counter.count >= 6) break;
                        customVarList.push(variantCustomId);
                    }
                }
            }
        
            storedVariants[productId] = { variants: customVarList };
            sessionStorage.setItem("natoriCustomVariants",JSON.stringify(storedVariants));
        
            if (uniqueColors.size > 5 && counter.count > 5) {
                const moreButtonHtml = `<div class="morebtn"><a href="${mainHandle}" intellisuggest="" ss-ps="">+ More</a></div>`;
                productDataElements.insertAdjacentHTML("beforeend", moreButtonHtml);
            }
        }
    };
    if (window.location.pathname.includes("/collections/")) {
        const productCards = document.querySelectorAll(".product-card-swatch");
    
        for (const card of productCards) {
            const prodOldSwatches = card.querySelector(".product-card-swatches");
            if (prodOldSwatches) {
                prodOldSwatches.innerHTML = "";
            }
        
            const productId = card.getAttribute("data-product-id");
            const productStyleNo = card.getAttribute("data-style-no");
            const color_settings = window["settings"];
            const settings = window[`settings_${productId}`];
        
            const __colorLookup = (window.NatoriColorSwatches && window.NatoriColorSwatches.getColorSwatchLookup)
            ? window.NatoriColorSwatches.getColorSwatchLookup()
            : (() => {
                const raw = (color_settings && color_settings.color_swatches) || '';
                const customColorsArray = raw.split(',').map((color) => {
                    const idx = color.indexOf(':');
                    if (idx === -1) return { key: color.trim().toLowerCase(), value: '' };
                    return { key: color.slice(0, idx).trim().toLowerCase(), value: color.slice(idx + 1).trim() || '' };
                });
                return {
                    keyArray: customColorsArray.map((color) => color.key),
                    valArray: customColorsArray.map((color) => color.value),
                };
            })();
            const keyArray = __colorLookup.keyArray;
            const valArray = __colorLookup.valArray;
        
            let productDetails;
            try {
                productDetails = await fetchProductDetails(productStyleNo);
            } catch (error) {
                console.error("Error fetching product details:", error);
                continue;
            }
        
            let uniqueColors = new Map();
            let counter = { count: 0 };
            for (const productDetail of productDetails) {
                const productAvailable = productDetail.totalInventory > 0;
                const discontinued = productDetail?.discontinued?.value === "true";
                if (productDetail && !discontinued && productAvailable) {
                    let primaryImagesrc = "";
                    let secondaryImagesrc = "";
                    if ( productDetail && productDetail.images && productDetail.images.edges ) {
                        const images = productDetail.images.edges.map((edge) => edge.node);
                        images.forEach((image, index) => {
                            if (index === 0) {
                                primaryImagesrc = image.src;
                            }
                            if (index === 1) {
                                secondaryImagesrc = image.src;
                            }
                        });
                    }
                    await processProductDetails(
                        productDetail,
                        keyArray,
                        valArray,
                        settings.featured_image_id,
                        document.getElementById("swatch_section_" + productId),
                        productId,
                        primaryImagesrc,
                        secondaryImagesrc,
                        settings.custom_handle,
                        uniqueColors,
                        counter,
                        productAvailable
                    );
                    if (counter.count >= 6) break;
                }
            }
            var swatchSection = document.getElementById("swatch_section_" + productId);
            if (swatchSection) {
                const productCardParent = swatchSection.closest('.product-card');
                if (productCardParent && typeof productCardParent.enableSwatches === 'function') {
                    productCardParent.enableSwatches();
                }
            }
        }
    } else {
        // Native Shopify product recommendations: hydrate from custom.available_color_swatches,
        // then fall back to Storefront product fetch (product_gids / tag:style).
        const hydrateNonCollectionSwatches = async () => {
            try {
                sessionStorage.removeItem('natoriCustomVariants');
            } catch (error) {
                // ignore storage failures
            }

            const productCards = document.querySelectorAll(
                'product-recommendations .product-card-swatch[data-product-id], .product-recommendations-drawer .product-card-swatch[data-product-id]'
            );
            const seen = new Set();

            for (const card of productCards) {
                const productId = card.getAttribute('data-product-id');
                if (!productId || seen.has(productId)) {
                    continue;
                }
                seen.add(productId);

                const prodOldSwatches = card.querySelector('.product-card-swatches');
                if (prodOldSwatches) {
                    prodOldSwatches.innerHTML = '';
                }

                const productStyleNo = card.getAttribute('data-style-no');
                const color_settings = window['settings'];
                const settings = window[`settings_${productId}`] || {};

                const __colorLookup = (window.NatoriColorSwatches && window.NatoriColorSwatches.getColorSwatchLookup)
                    ? window.NatoriColorSwatches.getColorSwatchLookup()
                    : (() => {
                        const raw = (color_settings && color_settings.color_swatches) || '';
                        const customColorsArray = raw.split(',').map((color) => {
                            const idx = color.indexOf(':');
                            if (idx === -1) return { key: color.trim().toLowerCase(), value: '' };
                            return { key: color.slice(0, idx).trim().toLowerCase(), value: color.slice(idx + 1).trim() || '' };
                        });
                        return {
                            keyArray: customColorsArray.map((color) => color.key),
                            valArray: customColorsArray.map((color) => color.value),
                        };
                    })();
                const keyArray = __colorLookup.keyArray;
                const valArray = __colorLookup.valArray;

                const container = document.getElementById('swatch_section_' + productId);
                const hydratedFromMetafield = hydrateRecommendationSwatchesFromMetafield(
                    productId,
                    settings,
                    container,
                    keyArray,
                    valArray
                );

                if (!hydratedFromMetafield) {
                    let productDetails;
                    try {
                        productDetails = await fetchRecommendationProductDetails(settings, productStyleNo);
                    } catch (error) {
                        console.error('Error fetching product details:', error);
                        continue;
                    }

                    if (!Array.isArray(productDetails) || !productDetails.length) {
                        continue;
                    }

                    const productCard = container?.closest('product-card');
                    if (productCard && window.GraphQLUtils?.hydrateProductCardMarketPrice) {
                        window.GraphQLUtils.hydrateProductCardMarketPrice(productCard, productDetails);
                    }

                    let uniqueColors = new Map();
                    let counter = { count: 0 };
                    for (const productDetail of productDetails) {
                        const productAvailable =
                            productDetail.totalInventory == null
                                ? true
                                : productDetail.totalInventory > 0;
                        const discontinued = productDetail?.discontinued?.value === 'true';
                        if (productDetail && !discontinued && productAvailable) {
                            let primaryImagesrc = '';
                            let secondaryImagesrc = '';
                            if (productDetail && productDetail.images && productDetail.images.edges) {
                                const images = productDetail.images.edges.map((edge) => edge.node);
                                images.forEach((image, index) => {
                                    if (index === 0) {
                                        primaryImagesrc = image.src;
                                    }
                                    if (index === 1) {
                                        secondaryImagesrc = image.src;
                                    }
                                });
                            }
                            await processProductDetails(
                                productDetail,
                                keyArray,
                                valArray,
                                settings.featured_image_id,
                                container,
                                productId,
                                primaryImagesrc,
                                secondaryImagesrc,
                                settings.custom_handle,
                                uniqueColors,
                                counter,
                                productAvailable
                            );
                            if (counter.count >= 6) break;
                        }
                    }
                }

                if (container) {
                    const productCardParent = container.closest('.product-card');
                    if (productCardParent && typeof productCardParent.enableSwatches === 'function') {
                        productCardParent.enableSwatches();
                    }
                }
            }
        };

        const hydrateNatoriRecommendationYotpo = async (root = document) => {
            const cards = [
                ...root.querySelectorAll(
                    'product-recommendations product-card, .product-recommendations-drawer product-card'
                ),
            ];

            if (!cards.length) {
                return;
            }

            if (window.YotpoUtils?.patchYotpoProductIds) {
                window.YotpoUtils.patchYotpoProductIds(root);
            }

            if (window.YotpoUtils?.processYotpoReviews) {
                await window.YotpoUtils.processYotpoReviews(cards);
            } else if (window.yotpo?.refreshWidgets) {
                try {
                    window.yotpo.refreshWidgets();
                } catch (error) {
                    console.warn('Yotpo refreshWidgets failed for recommendations', error);
                }
            }
        };

        const hydrateNatoriRecommendations = async (root = document) => {
            await hydrateNonCollectionSwatches();

            if (window.GraphQLUtils?.hydrateRecommendationMarketPrices) {
                await window.GraphQLUtils.hydrateRecommendationMarketPrices(root);
            }

            await hydrateNatoriRecommendationYotpo(root);
        };

        window.hydrateNatoriRecommendationSwatches = hydrateNonCollectionSwatches;
        window.hydrateNatoriRecommendationPrices = (root = document) =>
            window.GraphQLUtils?.hydrateRecommendationMarketPrices?.(root);
        window.hydrateNatoriRecommendationYotpo = hydrateNatoriRecommendationYotpo;
        window.hydrateNatoriRecommendations = hydrateNatoriRecommendations;

        setTimeout(() => {
            hydrateNatoriRecommendations();
        }, 2000);
    }
});
  